<template>
  <tr :class="[
    isBody && 'hover:bg-light-300 dark:hover:bg-dark-600 odd:bg-light-50 even:bg-light-100 dark:odd:bg-dark-800 dark:even:bg-dark-600',
    customClass
  ]">
    <slot></slot>
  </tr>
</template>

<script>
export default {
  name: 'TableRow',
  props: {
    alternateRow: {
      type: Boolean,
      default: false
    },
    isBody: {
      type: Boolean,
      default: false
    },
    index: {
      type: Number,
      default: 0
    },
    customClass: {
      type: String,
      default: ''
    }
  }
}
</script>
